const id_trans_initstock = {
    "": "stok awal",

    message: {
        note: "CATATAN : hanya format excel yang bisa diunggah !",
        note_excel: "Unduh Contoh file EXCEL",
        note_term_title: "Ketentuan file :",
        note_term_1: "Gunakan file contoh",
        note_term_2: "Kolom yang terdapat tanda '*' wajib diisi",
        note_term_3: "NoLot/SerialNumber : diisi jika memiliki serial number atau no lot",
        note_term_4: "NoLot/SerialNumber wajib diisi jika : barang bertipe serial number",
    },

    error: {
        create: "Gagal menginisialisasi stok gudang",
        download_file: "Gagal mengunduh file",
    },

    success: {
        create: "Berhasil menginisialisasi stok gudang",
    },
}

export default id_trans_initstock;